import Cookies from "universal-cookie";
const cookies = new Cookies();

const cookieOptions = {
  path: "/",
  secure: true,
  httpOnly: false,
  sameSite: true,
};

let token = false;
let user = {
  countryCode: "",
  userType: "",
};
let userType = "";

function setToken(propToken) {
  token = propToken;
}

function setUser(paramUser) {
  user = paramUser;
}

function setUserType(type) {
  userType = type;
}

function saveSession(user) {
  if (user.opaque !== undefined) {
    cookies.set("USER-SESSION", user.opaque, cookieOptions);
  }
}

function logout() {
  cookies.remove("USER-SESSION", cookieOptions);
}

function getAuthorization() {
  // return cookies.get('USER-SESSION');
  return token;
}

function getUser() {
  return user;
}

function getUserType() {
  return userType;
}

const getLanguage = () => cookies.get("i18nextLng");

const saveLanguage = (lng) => {
  cookies.set("i18nextLng", lng, cookieOptions);
};

export default {
  saveSession: saveSession,
  getAuthorization: getAuthorization,
  getUser,
  getUserType,
  logout: logout,
  setToken: setToken,
  setUser,
  setUserType,
  getLanguage,
  saveLanguage,
};
